"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var env_1 = require("./env");
function enhanceWithRouter(_a) {
    var withRouter = _a.withRouter, createElement = _a.createElement;
    if (env_1.isMiniAppPlatform) {
        withRouter = function (Component) {
            function Wrapper(props) {
                // eslint-disable-next-line
                var history = window.history;
                return createElement(Component, Object.assign({}, props, {
                    history: history,
                    location: history.location,
                }));
            }
            // eslint-disable-next-line
            Wrapper.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
            Wrapper.WrappedComponent = Component;
            return Wrapper;
        };
    }
    return withRouter;
}
exports.default = enhanceWithRouter;
